import { useState } from 'react';
import { QEScoreRecommendedActionCard } from './ActionCard';
import { RecommendedActionsFilterBar } from './RecommendedActionsSearch';
import { useStyles } from '../../../../styles';
import { QeScoreRecommendedAction } from '../../../../interfaces';

export function RecommendedActions({
  actions,
}: {
  actions: QeScoreRecommendedAction[];
}) {
  const classes = useStyles();
  const [searchText, setSearchText] = useState<string>('');
  const [priorityFilter, setPriorityFilter] = useState<string>(
    'All priority levels',
  );

  // Filter actions based on selected priority and search text
  const filteredActions = actions.filter(action => {
    const normalizedSearchText = searchText.trim().toLowerCase();
    const matchesSearch =
      normalizedSearchText.length === 0 ||
      action.title.toLowerCase().includes(normalizedSearchText) ||
      action.actionText.toLowerCase().includes(normalizedSearchText);

    if (!matchesSearch) return false;

    if (priorityFilter === 'High Priority')
      return action.priority.toLowerCase() === 'high';
    if (priorityFilter === 'Medium Priority')
      return action.priority.toLowerCase() === 'medium';
    if (priorityFilter === 'Low Priority')
      return action.priority.toLowerCase() === 'low';
    return true;
  });

  return (
    <div
      className={`rounded-lg shadow-sm ${classes.recommendedActionsContainer}`}
    >
      <h3
        className={`text-xl font-semibold mb-3 ${classes.recommendedActionsTitle}`}
      >
        Recommended Actions
      </h3>

      <RecommendedActionsFilterBar
        searchText={searchText}
        onSearchTextChange={setSearchText}
        priorityFilter={priorityFilter}
        onPriorityFilterChange={setPriorityFilter}
      />

      {/* Action items */}
      <div className="space-y-3 sm:space-y-4">
        {filteredActions.map(action => (
          <QEScoreRecommendedActionCard
            key={action.actionId}
            actionItem={action}
          />
        ))}
      </div>

      {/* Empty state */}
      {filteredActions.length === 0 && (
        <div className="text-center py-8">
          <p className={`text-sm ${classes.recommendedActionsEmptyStateText}`}>
            No actions found for the selected filters.
          </p>
        </div>
      )}
    </div>
  );
}
